module.exports = __webpack_public_path__ + "img/card-online.f358359e.png";